import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Check } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { SERVICES } from "@/lib/data";

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-char text-[var(--astera-bone)] py-28 lg:py-40">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
      <div className="grid lg:grid-cols-12 gap-8 items-end mb-16">
        <div className="lg:col-span-8">
          <Reveal>
            <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[var(--astera-olive-light)]">
              <span className="h-[1px] w-10 bg-[var(--astera-olive-light)]" /> What we treat
            </p>
            <h2 className="font-serif font-light text-4xl md:text-6xl leading-[1.02] tracking-tight">
              Whole-woman medicine for the <span className="italic text-clay">middle chapters.</span>
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <p className="text-[var(--astera-bone)]/60 leading-relaxed">
              Every service is delivered by a physician — grounded in the latest
              evidence, with the time and attention midlife care demands.
            </p>
          </Reveal>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 gap-px bg-white/10 rounded-[28px] overflow-hidden">
        {SERVICES.map((s, i) => {
          const Icon = Icons[s.icon] || Icons.Sparkles;
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.08}>
              <motion.div
                whileHover={{ backgroundColor: "rgba(196,139,113,0.14)" }}
                data-testid={`service-card-${i}`}
                className="group h-full bg-[var(--astera-char)] p-9 lg:p-11 transition-colors duration-300"
              >
                <div className="flex items-center justify-between">
                  <Icon size={30} strokeWidth={1.2} className="text-clay" />
                  <span className="font-serif text-2xl text-white/15">0{i + 1}</span>
                </div>
                <h3 className="mt-10 font-serif text-2xl md:text-[1.7rem] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-[var(--astera-bone)]/55">
                  {s.desc}
                </p>
                <ul className="mt-6 space-y-3 border-t border-white/10 pt-6">
                  {s.points.map((p, k) => (
                    <li key={k} className="flex items-start gap-3 text-sm text-[var(--astera-bone)]/75">
                      <Check size={16} strokeWidth={1.6} className="mt-0.5 shrink-0 text-clay" />
                      <span>{p}</span>
                    </li>
                  ))}
                </ul>
              </motion.div>
            </Reveal>
          );
        })}

        <Reveal delay={0.16}>
          <a
            href="#contact"
            data-testid="service-card-cta"
            className="group flex h-full flex-col justify-between bg-olive p-9 lg:p-11 transition-colors duration-300 hover:bg-[var(--astera-olive-deep)]"
          >
            <span className="font-serif text-2xl text-white/25">04</span>
            <div>
              <h3 className="font-serif text-2xl md:text-[1.7rem] leading-tight text-[var(--astera-bone)]">
                Not sure where to start?
              </h3>
              <p className="mt-4 text-sm leading-relaxed text-[var(--astera-bone)]/80">
                Book a confidential consultation and we'll help you find the right path forward.
              </p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.16em] text-[var(--astera-bone)]">
                Book Appointment
                <Icons.ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
